const COMMON_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.ca',
  'yahoo.com.au',
  'yahoo.com.sg',
  'ymail.com',
  'rocketmail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'hotmail.it',
  'live.com',
  'live.co.uk',
  'msn.com',
  'passport.com',
  'passport.net',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'aim.com',
  'proton.me',
  'protonmail.com',
  'pm.me',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'mail.com',
  'email.com',
  'zoho.com',
  'yandex.com',
  'yandex.ru',
  'bk.ru',
  'inbox.ru',
  'list.ru',
  'mail.ru',
  'qq.com',
  '163.com',
  '126.com',
  'yeah.net',
  'sina.com',
  'sina.cn',
  'sohu.com',
  'naver.com',
  'hanmail.net',
  'daum.net',
  'rediffmail.com',
  'indiatimes.com',
  'web.de',
  'freenet.de',
  't-online.de',
  'libero.it',
  'virgilio.it',
  'alice.it',
  'orange.fr',
  'wanadoo.fr',
  'laposte.net',
  'free.fr',
  'seznam.cz',
  'centrum.cz',
  'wp.pl',
  'onet.pl',
  'o2.pl',
  'interia.pl',
  'abv.bg',
  'mail.bg',
  'ukr.net',
  'meta.ua',
  'rambler.ru',
  'bol.com.br',
  'uol.com.br',
  'terra.com.br',
  'ig.com.br',
  'terra.com',
  'att.net',
  'verizon.net',
  'comcast.net',
  'cox.net',
  'sbcglobal.net',
  'bellsouth.net',
  'charter.net',
  'shaw.ca',
  'rogers.com',
  'telus.net',
  'btinternet.com',
  'virginmedia.com',
  'sky.com',
  'talktalk.net',
  'ntlworld.com',
  'blueyonder.co.uk',
  'fastmail.com',
  'fastmail.fm',
  'hushmail.com',
  'tutanota.com',
  'tutanota.de',
  'posteo.de',
  'mailbox.org',
  'runbox.com',
  'hey.com',
  'duck.com',
  'disroot.org',
  'riseup.net',
  'mailfence.com',
  'hush.com',
  'lavabit.com',
  'airmail.cc',
  'inbox.com',
  'myway.com',
  'usa.com',
  'consultant.com',
  'engineer.com',
  'dr.com',
  'accountant.com',
  'mailinator.com',
  'guerrillamail.com',
  'guerrillamailblock.com',
  'sharklasers.com',
  'grr.la',
  'guerrillamail.biz',
  'guerrillamail.de',
  'guerrillamail.net',
  'guerrillamail.org',
  'temp-mail.org',
  'tempmail.com',
  '10minutemail.com',
  'yopmail.com',
  'trashmail.com',
  'throwawaymail.com',
  'getnada.com',
  'maildrop.cc',
  'dropmail.me',
  'dispostable.com',
  'fakeinbox.com',
  'mintemail.com',
  'spamgourmet.com',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'emailondeck.com',
  'mohmal.com',
]);

export function extractEmailDomain(email) {
  const value = String(email || '').trim().toLowerCase();
  const parts = value.split('@');
  return parts.length === 2 ? parts[1] : '';
}

export function isCommonEmailDomain(email) {
  return COMMON_EMAIL_DOMAINS.has(extractEmailDomain(email));
}
